import { useState, useEffect, useCallback } from "react";
import { fetchVideosAPI } from "../api/videos";

export const useVideos = (initialPage = 1, limit = 6) => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);

  const fetchVideos = useCallback(async (pageNum = initialPage) => {
    try {
      setLoading(true);
      const data = await fetchVideosAPI(pageNum, limit);
      
      if (data && data.videos) {
        if (pageNum === 1) {
          setVideos(data.videos);
        } else {
          setVideos((prev) => [...prev, ...data.videos]);
        }
        setTotalPages(data.totalPages);
      }
    } catch (error) {
      console.error("Error fetching videos:", error);
    } finally {
      setLoading(false);
    }
  }, [initialPage, limit]);

  const loadMore = useCallback(() => {
    if (page < totalPages && !loading) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchVideos(nextPage);
    }
  }, [page, totalPages, loading, fetchVideos]);

  useEffect(() => {
    fetchVideos(initialPage);
  }, [initialPage, fetchVideos]);

  return {
    videos,
    loading,
    page,
    totalPages,
    loadMore,
  };
};